import * as React from 'react';
import { ModalWindow } from '@cian/ui-kit';

import { BanksList } from './components/BanksList';
import { PromoDescription } from './components/PromoDescription';
import * as styles from './PromoDetailsModal.css';
import { IPromoProp } from '../../types/specialPromos/promoProp';
import { IPromoPopupBank } from '../../types/specialPromos/promoPopup';

interface IPromoDetailsModalProps {
  banks: IPromoPopupBank[];
  description?: string | null;
  features: IPromoProp[];
  logo: string;
  promoName: string;
  providerName: string;
  newbuildingLinksList: React.ReactNode;
  linkButton: React.ReactNode;
  onClose(): void;
}

export const PromoDetailsModal: React.FC<IPromoDetailsModalProps> = ({
  banks,
  description,
  features,
  logo,
  promoName,
  providerName,
  newbuildingLinksList,
  linkButton,
  onClose,
}) => {
  return (
    <ModalWindow
      open={true}
      onClose={onClose}
      width="100%"
      maxWidth={648}
      footer={<div className={styles['button-container']}>{linkButton}</div>}
    >
      <div className={styles['container']} data-testid="PromoDetailsModal">
        <div className={styles['section']}>
          <PromoDescription
            promoName={promoName}
            providerName={providerName}
            logo={logo}
            description={description}
            features={features}
          />
        </div>
        {banks.length > 0 && (
          <div className={styles['section']}>
            <BanksList banks={banks} />
          </div>
        )}
        <div className={styles['section']}>{newbuildingLinksList}</div>
      </div>
    </ModalWindow>
  );
};
